import { render, staticRenderFns } from "./PreviewPlayer.vue?vue&type=template&id=bce6cb94&scoped=true&"
import script from "./PreviewPlayer.vue?vue&type=script&lang=js&"
export * from "./PreviewPlayer.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPlayer.vue?vue&type=style&index=0&id=bce6cb94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce6cb94",
  null
  
)

export default component.exports